import { TZDate } from '@date-fns/tz';

/**
 * Mimics date-fns-tz's `zonedTimeToUtc`: treats the input as
 * if it were in the given timezone and converts it to UTC
 *
 * @param input - A string like "2025-06-11T10:30:00" (local time)
 * @param timeZone - IANA timezone like "America/Regina"
 * @returns A UTC Date object
 */
export default function zonedTimeToUtc(input: string, timeZone: string): Date {
  return new Date(new TZDate(input, timeZone).getTime());
}
